import React from 'react';
import VotingList from '../components/VotingList';
import ProtectedRoute from '../components/ProtectedRoute';
import { useVotingOptions } from '../context/VotingOptionsContext';

const VoteSite = () => {
  const { options, isLoading, error } = useVotingOptions();

  return (
    <ProtectedRoute>
      <div className="voting-page-container">
        <div className="container">
          <VotingList
            title="請投選10個最熱門媒體網站"
            subtitle="（投票前，可點擊‘前往’瀏覽其網站了解更多）"
            nextUrl="/voting/fb"
            items={options.site}
            maxSelections={10}
            storageKey="site"
            forceLoading={isLoading}
            forceError={error}
          />
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default VoteSite;
